<form
  [formGroup]="commentForm"
  (ngSubmit)="submit()"
  class="chat-input-form flex w-full rounded"
  [ngClass]="{ 'flex-col': mode === 'edit', 'with-bg items-center': mode === 'create' }"
>
  <y42-chat-avatar *ngIf="mode === 'create'" [avatar]="avatar" class="flex p-2 mt-1"></y42-chat-avatar>

  <quill-editor
    #quillEditor
    [formControlName]="'comment'"
    [format]="'json'"
    [formats]="formats"
    [modules]="quillConfig"
    [bounds]="'self'"
    [placeholder]="'Share your thoughts'"
    [theme]="'bubble'"
    [trimOnValidation]="true"
    [required]="true"
    class="survey-text-editor w-full"
    [ngClass]="{ 'hide-toolbar-tooltip': true }"
    (onEditorCreated)="editorCreated($event)"
    (onContentChanged)="contentChanged($event)"
  >
  </quill-editor>

  <div class="flex p-2 mt-1" *ngIf="mode === 'create'">
    <button mat-mini-fab color="primary" [type]="'submit'" class="chat-input-submit">
      <fa-icon class="flex fs-1" [icon]="['fal', 'paper-plane-top']"></fa-icon>
    </button>
  </div>

  <div *ngIf="mode === 'edit'" class="text-primary-700 relative">
    <ng-container *ngIf="state.lastTextValue">
      <span class="save-btn" (click)="submit()">Save</span>
      <span class="dot-decor ml-2 mr-2 relative">.</span>
    </ng-container>
    <span class="cancel-btn" (click)="cancel()">Cancel</span>
  </div>
</form>
